import * as Sentry from '@sentry/react';
import env from './env';

const init = () => {
  if (process.env.REACT_APP_SENTRY_KEY) {
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY_KEY,
      integrations: [Sentry.browserTracingIntegration()],
      release: process.env.REACT_APP_VERSION,
      environment: env.getEnv(),
      debug: process.env.NODE_ENV === 'development',
      // Performance monitoring
      tracesSampleRate: parseFloat(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE ?? '0'),
      denyUrls: [
        // Chrome extensions
        /extensions\//i,
        /^chrome:\/\//i,
        /^chrome-extension:\/\//i,
      ],
    });
  }
};

const setUser = data => {
  if (process.env.REACT_APP_SENTRY_KEY) {
    Sentry.setUser(data);
  }
};

const log = (message, data) => {
  if (process.env.REACT_APP_SENTRY_KEY) {
    Sentry.captureMessage(message, data);
  }
};

const logError = (message, metadata) => {
  log(message, { level: 'error', ...metadata });
};

const logWarning = (message, metadata) => {
  log(message, { level: 'warning', ...metadata });
};

const logDebug = (message, metadata) => {
  log(message, { level: 'debug', ...metadata });
};

const addRequestIdBreadcrumb = (endpoint, status, requestId) => {
  if (process.env.REACT_APP_SENTRY_KEY) {
    Sentry.addBreadcrumb({
      category: 'x-request-id',
      message: `${endpoint} [${status}] x-request-id: ${requestId}`,
      level: 'info',
    });
  }
};

const sentryMethods = {
  init,
  setUser,
  logError,
  logWarning,
  logDebug,
  addRequestIdBreadcrumb,
};

export default sentryMethods;
